import { render, staticRenderFns } from "./initiate-detail.vue?vue&type=template&id=a2a79258&scoped=true&"
import script from "./initiate-detail.vue?vue&type=script&lang=js&"
export * from "./initiate-detail.vue?vue&type=script&lang=js&"
import style0 from "./initiate-detail.vue?vue&type=style&index=0&id=a2a79258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a79258",
  null
  
)

export default component.exports